import { defineProductDimensions, rcphPricingVersionDimension, rcphSelectedDimension } from '@orus.eu/dimensions'

import { rcphVersionDimension } from './rcph-activity-vocabulary.ts'
import { rcphQuoteV2Dimension, rcphQuoteV3Dimension } from './rcph-quote-dimension.ts'

export * from './rcph-activity-vocabulary.ts'
export * from './rcph-dimensions.ts'
export * from './rcph-subscription-ui.ts'

export const rcphDimensionsModule = defineProductDimensions({
  product: 'rcph',
  family: null,
  selectionDimension: rcphSelectedDimension,
  legacyVersionDimension: rcphVersionDimension, // name 'rcphVersion' — permanent override (D6), never renamed
  pricingVersionDimension: rcphPricingVersionDimension,
  quoteV2Dimension: rcphQuoteV2Dimension,
  quoteV3Dimension: rcphQuoteV3Dimension,
})
